export const INITIATE_MUSATAHA_APPLICATION = 'INITIATE_MUSATAHA_APPLICATION';
export const INITIATE_MUSATAHA_APPLICATION_SUCCESS = 'INITIATE_MUSATAHA_APPLICATION_SUCCESS';
export const INITIATE_MUSATAHA_APPLICATION_ERROR = 'INITIATE_MUSATAHA_APPLICATION_ERROR';

export const FETCH_MUSATAHA_APPLICATION = 'FETCH_MUSATAHA_APPLICATION';
export const FETCH_MUSATAHA_APPLICATION_SUCCESS = 'FETCH_MUSATAHA_APPLICATION_SUCCESS';
export const FETCH_MUSATAHA_APPLICATION_ERROR = 'FETCH_MUSATAHA_APPLICATION_ERROR';

export const FETCH_MUSATAHA_CONTRACT = 'FETCH_MUSATAHA_CONTRACT';
export const FETCH_MUSATAHA_CONTRACT_SUCCESS = 'FETCH_MUSATAHA_CONTRACT_SUCCESS';
export const FETCH_MUSATAHA_CONTRACT_ERROR = 'FETCH_MUSATAHA_CONTRACT_ERROR';
export const FETCH_MUSATAHA_BUYER = 'FETCH_MUSATAHA_BUYER';
export const FETCH_MUSATAHA_BUYER_SUCCESS = 'FETCH_MUSATAHA_BUYER_SUCCESS';
export const FETCH_MUSATAHA_BUYER_ERROR = 'FETCH_MUSATAHA_BUYER_ERROR';

export const ADD_MUSATAHA_BUYER = 'ADD_MUSATAHA_BUYER';
export const ADD_MUSATAHA_BUYER_SUCCESS = 'ADD_MUSATAHA_BUYER_SUCCESS';
export const ADD_MUSATAHA_BUYER_ERROR = 'ADD_MUSATAHA_BUYER_ERROR';

export const DELETE_MUSATAHA_BUYER = 'DELETE_MUSATAHA_BUYER';
export const DELETE_MUSATAHA_BUYER_SUCCESS = 'DELETE_MUSATAHA_BUYER_SUCCESS';
export const DELETE_MUSATAHA_BUYER_ERROR = 'DELETE_MUSATAHA_BUYER_ERROR';

export const FETCH_APPLICATION_WAIVE_MUSATAHA = 'FETCH_APPLICATION_WAIVE_MUSATAHA';
export const FETCH_APPLICATION_WAIVE_MUSATAHA_SUCCESS = 'FETCH_APPLICATION_WAIVE_MUSATAHA_SUCCESS';
export const FETCH_APPLICATION_WAIVE_MUSATAHA_ERROR = 'FETCH_APPLICATION_WAIVE_MUSATAHA_ERROR';

export const DOWNLOAD_DOCUMENT_MUSATAHA = 'DOWNLOAD_DOCUMENT_MUSATAHA';
export const DOWNLOAD_DOCUMENT_MUSATAHA_SUCCESS = 'DOWNLOAD_DOCUMENT_MUSATAHA_SUCCESS';
export const DOWNLOAD_DOCUMENT_MUSATAHA_ERROR = 'DOWNLOAD_DOCUMENT_MUSATAHA_ERROR';

export const ADD_TO_ERROR = 'ADD_TO_ERROR';
export const ADD_TO_ERROR_INITITATE = 'ADD_TO_ERROR_INITITATE';

export const SAVE_APPLICATION_MUSATAHA_WAIVER = 'SAVE_APPLICATION_MUSATAHA_WAIVER';
export const SAVE_APPLICATION_MUSATAHA_WAIVER_SUCCESS = 'SAVE_APPLICATION_MUSATAHA_WAIVER_SUCCESS';
export const SAVE_APPLICATION_MUSATAHA_WAIVER_ERROR = 'SAVE_APPLICATION_MUSATAHA_WAIVER_ERROR';

export const CHANGE_FORM = 'CHANGE_FORM';

export const MUSATAHA_FIELD_CHANGE = 'MUSATAHA_FIELD_CHANGE';

export const FETCH_MUSATAHA_APPLICATION_PAYMENT_BREAKDOWN = 'FETCH_MUSATAHA_APPLICATION_PAYMENT_BREAKDOWN';
export const FETCH_MUSATAHA_APPLICATION_PAYMENT_BREAKDOWN_SUCCESS =
  'FETCH_MUSATAHA_APPLICATION_PAYMENT_BREAKDOWN_SUCCESS';
export const FETCH_MUSATAHA_APPLICATION_PAYMENT_BREAKDOWN_ERROR = 'FETCH_MUSATAHA_APPLICATION_PAYMENT_BREAKDOWN_ERROR';

export const SAVE_MUSATAHA_APPLICATION = 'SAVE_MUSATAHA_APPLICATION';
export const SAVE_MUSATAHA_APPLICATION_SUCCESS = 'SAVE_MUSATAHA_APPLICATION_SUCCESS';
export const SAVE_MUSATAHA_APPLICATION_ERROR = 'SAVE_MUSATAHA_APPLICATION_ERROR';

export const MUSATAHA_FORM_VALIDATION_ERROR = 'MUSATAHA_FORM_VALIDATION_ERROR';
export const MUSATAHA_CHANGE_APPLICATION_STEP = 'MUSATAHA_CHANGE_APPLICATION_STEP';

export const UPLOAD_MUSATAHA_DOCUMENT = 'UPLOAD_MUSATAHA_DOCUMENT';
export const UPLOAD_MUSATAHA_DOCUMENT_SUCCESS = 'UPLOAD_MUSATAHA_DOCUMENT_SUCCESS';
export const UPLOAD_MUSATAHA_DOCUMENT_ERROR = 'UPLOAD_MUSATAHA_DOCUMENT_ERROR';

export const DOWNLOAD_MUSATAHA_DOCUMENT = 'DOWNLOAD_MUSATAHA_DOCUMENT';
export const DOWNLOAD_MUSATAHA_DOCUMENT_SUCCESS = 'DOWNLOAD_MUSATAHA_DOCUMENT_SUCCESS';
export const DOWNLOAD_MUSATAHA_DOCUMENT_ERROR = 'DOWNLOAD_MUSATAHA_DOCUMENT_ERROR';

export const DELETE_MUSATAHA_DOCUMENT = 'DELETE_MUSATAHA_DOCUMENT';
export const DELETE_MUSATAHA_DOCUMENT_SUCCESS = 'DELETE_MUSATAHA_DOCUMENT_SUCCESS';
export const DELETE_MUSATAHA_DOCUMENT_ERROR = 'DELETE_MUSATAHA_DOCUMENT_ERROR';

export const GET_MUSATAHA_DOCUMENTS = 'GET_MUSATAHA_DOCUMENTS';
export const GET_MUSATAHA_DOCUMENTS_SUCCESS = 'GET_MUSATAHA_DOCUMENTS_SUCCESS';
export const GET_MUSATAHA_DOCUMENTS_ERROR = 'GET_MUSATAHA_DOCUMENTS_ERROR';

export const CHECKOUT_MUSATAHA_APPLICATION = 'CHECKOUT_MUSATAHA_APPLICATION';
export const CHECKOUT_MUSATAHA_APPLICATION_SUCCESS = 'CHECKOUT_MUSATAHA_APPLICATION_SUCCESS';
export const CHECKOUT_MUSATAHA_APPLICATION_ERROR = 'CHECKOUT_MUSATAHA_APPLICATION_ERROR';

export const DOWNLOAD_MUSATAHA_CONTRACT_DOCUMENT = 'DOWNLOAD_MUSATAHA_CONTRACT_DOCUMENT';
export const DOWNLOAD_MUSATAHA_CONTRACT_DOCUMENT_SUCCESS = 'DOWNLOAD_MUSATAHA_CONTRACT_DOCUMENT_SUCCESS';
export const DOWNLOAD_MUSATAHA_CONTRACT_DOCUMENT_ERROR = 'DOWNLOAD_MUSATAHA_CONTRACT_DOCUMENT_ERROR';

export const MUSATAHA_CANCEL_APPLICATION = 'MUSATAHA_CANCEL_APPLICATION';
export const MUSATAHA_CANCEL_APPLICATION_SUCCESS = 'MUSATAHA_CANCEL_APPLICATION_SUCCESS';
export const MUSATAHA_CANCEL_APPLICATION_ERROR = 'MUSATAHA_CANCEL_APPLICATION_ERROR';

export const CLEAR_MUSATAHA_APPLICATION_ERROR = 'CLEAR_MUSATAHA_APPLICATION_ERROR';

export const MUSATAHA_PROPERTY_DOCUMENTS = 'MUSATAHA_PROPERTY_DOCUMENTS';
export const MUSATAHA_PROPERTY_DOCUMENTS_SUCCESS = 'MUSATAHA_PROPERTY_DOCUMENTS_SUCCESS';
export const MUSATAHA_PROPERTY_DOCUMENTS_ERROR = 'MUSATAHA_PROPERTY_DOCUMENTS_ERROR';

export const CLEAR_MUSATAHA_CONTRACT_PERIOD = 'CLEAR_MUSATAHA_CONTRACT_PERIOD';
